import { Button } from "antd";
import { MessageOutlined } from "@ant-design/icons";
import { useState } from "react";
import { StyledConversationsWidget } from "./styles";
import Conversations from ".";

const ConversationsWidget = (props) => {
  const [widgetOpen, setWidgetOpen] = useState(true);

  return (
    <StyledConversationsWidget className={widgetOpen ? "open" : ""}>
      <Button
        icon={<MessageOutlined />}
        type="primary"
        shape="square"
        className="message-btn"
        onClick={() => setWidgetOpen(true)}
      >
        <span className="btn-text">Conversations</span>
      </Button>
      <div className={!widgetOpen ? "d-none" : "h-100 widget-body"}>
        <Conversations {...props} setWidgetOpen={setWidgetOpen} />
      </div>
    </StyledConversationsWidget>
  );
};

export default ConversationsWidget;
